import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function SmallPoAMonitoring() {
  return (
    <div className="art-page">
      <SEO
        title="Gold Standard PoA Monitoring — Supporting Uganda's Emerging Clean Cooking Enterprises"
        description="CIRCODU provides independent WBT monitoring services to Uganda's smaller and emerging clean cooking enterprises seeking Gold Standard carbon credit verification."
        keywords="Gold Standard, PoA monitoring, clean cooking, Uganda, carbon finance, emissions reduction, sustainable energy, cookstove testing, carbon project development, independent monitoring organization, carbon credit verification, CIRCODU, Gold Standard monitoring Uganda, clean cooking monitoring Uganda, cookstove testing Uganda, carbon project development Uganda, independent monitoring organization Uganda, carbon credit verification Uganda"
        url="/Gold-Standard-PoA-Monitoring-Supporting-Ugandas-Emerging-Clean-Cooking-Enterprises"
        datePublished="2024-10-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Gold Standard PoA Monitoring — CHARMAX, Pro-sphera, All Green
              Energy and NAAWAD
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              October 01, 2024
            </div>
            <h1 className="art-title">
              Gold Standard PoA Monitoring — Supporting Uganda's Emerging Clean
              Cooking Enterprises
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                Alongside its ongoing multi-year monitoring relationships with
                established partners, CIRCODU provides independent WBT
                monitoring services to a range of Uganda's smaller and emerging
                clean cooking enterprises seeking Gold Standard carbon credit
                verification. In 2023 and 2024, CIRCODU conducted monitoring
                studies for four such clients, each requiring laboratory-based
                thermal efficiency testing on field-sampled stoves.
              </p>
              <p>
                For smaller enterprises, accessing credible, internationally
                recognised independent testing has historically been a barrier
                to Gold Standard carbon market participation. CIRCODU's
                accessible, professional laboratory testing service lowers that
                barrier — enabling domestic manufacturers to compete credibly in
                Uganda's growing carbon market.
              </p>
              <h2 className="art-subheading">2023–2024 Monitoring Studies</h2>
              <ol>
                <li>
                  <strong>CHARMAX (January 2023):</strong> Water Boiling Tests
                  on CHARMAX stove models following the ISO 19867-1:2018
                  standard, verifying in-field thermal efficiency for carbon
                  monitoring purposes.
                </li>
                <li>
                  <strong>Pro-sphera (February 2024):</strong> WBT testing on
                  Pro-sphera stoves following WBT Version 4.2.3, providing the
                  performance data needed to support PoA verification.
                </li>
                <li>
                  <strong>All Green Energy (October 2024):</strong> Water
                  Boiling Tests on All Green Energy stove models collected from
                  the field, with results compiled in a formal monitoring
                  report.
                </li>
                <li>
                  <strong>NAAWAD Briquette Stoves (July 2024):</strong> Testing
                  of NAAWAD's briquette stove models, measuring thermal
                  efficiency to support Gold Standard PoA monitoring for this
                  producer of briquette-compatible cookstoves.
                </li>
              </ol>
            </div>
            <div className="art-cta">
              <p>
                Interested in Gold Standard PoA monitoring for your cookstove
                programme? Contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
